import { useMutation, useQuery } from '@tanstack/react-query';
import { getRegisterDemoUser, postRegisterDemoUser } from './api';
import { useAddSnackbarMessage } from '@shared/useAddSnackBar';
import { useIntlTranslations } from '@libs/intl/intl.hooks';

export interface DemoUserRegistrationData {
  email: string;
  gdprConsent: boolean;
  subscriptionState: string;
}

export const useRegisterDemoUserMutation = () => {
  const addSnackBarMessage = useAddSnackbarMessage();
  const { t } = useIntlTranslations('demo.mutation');

  return useMutation<void, Error, DemoUserRegistrationData>({
    mutationFn: async (data: DemoUserRegistrationData) => postRegisterDemoUser(data),
    onSuccess: () => {
      addSnackBarMessage({ text: t('registerSuccess'), type: 'success' });
    },
    onError: error => {
      addSnackBarMessage({ text: t('registerError'), type: 'error' });
    },
  });
};
export const useRegisterDemoUserQuery = () => {
  return useQuery({
    queryFn: async () => getRegisterDemoUser(),
    queryKey: ['demoUserRegistration'],
  });
};
